<template>
  <div>
    <div class="row mb-3">
      <div class="col-md-6" v-show="isNumerationFile">
        <list-subject-types
          class="w-100"
          autocomplete
          label="Distribución"
          name="copySubjectType"
          v-model="copySubjectForm.copySubjectType"
          v-validate="'required'"
          :danger="errors.has(`${scope}.copySubjectType`)"
          :danger-text="errors.first(`${scope}.copySubjectType`)"
          ref="copySubjectType"
          :is-doc-digital="isDocDigital"
        />
      </div>
      <div class="col-md-6" v-show="isNumerationFile">
        <ListSanitaryCompanies
          with-email
          v-if="copySubjectForm.copySubjectType === 'sanitarias'"
          autocomplete="off"
          data-vv-as="empresa sanitaria"
          v-model="copySubjectForm.copySubject"
          name="copySubject"
          :isClearable="true"
          ref="copySubject"
          v-validate="{
            required: copySubjectForm.copySubjectType === 'sanitarias',
            max: '200'
          }"
          :danger="errors.has(`${scope}.copySubject`)"
          :danger-text="errors.first(`${scope}.copySubject`)"
        />
        <list-offices
          v-if="
              !isInput.includes(copySubjectForm.copySubjectType)
                && copySubjectForm.copySubjectType === 'oficinas'
            "
          class="w-100"
          autocomplete
          label="Oficina"
          name="copySubject"
          v-model="copySubjectForm.copySubject"
          :danger="errors.has(`${scope}.copySubject`)"
          :danger-text="errors.first(`${scope}.copySubject`)"
          v-validate="{ required:  !isInput.includes(copySubjectForm.copySubjectType)
                && copySubjectForm.copySubjectType === 'oficinas' }"
          ref="copySubject"
        />
        <list-groups
          v-if="
              !isInput.includes(copySubjectForm.copySubjectType)
                && copySubjectForm.copySubjectType === 'unidades'
            "
          class="w-100"
          autocomplete
          label="Unidad"
          name="copySubject"
          :typeList="1"
          v-model="copySubjectForm.copySubject"
          :danger="errors.has(`${scope}.copySubject`)"
          :danger-text="errors.first(`${scope}.copySubject`)"
          v-validate="{ required:  !isInput.includes(copySubjectForm.copySubjectType)
                && copySubjectForm.copySubjectType === 'unidades' }"
          ref="copySubject"
        />
        <list-subjects
          v-if="
              !isInput.includes(copySubjectForm.copySubjectType)
                && copySubjectForm.copySubjectType !== 'usuarios'
                && copySubjectForm.copySubjectType !== 'oficinas'
                && copySubjectForm.copySubjectType !== 'unidades'
                && copySubjectForm.copySubjectType !== 'sanitarias'
            "
          class="w-100"
          autocomplete
          label="Lista de Destino"
          name="copySubject"
          v-model="copySubjectForm.copySubject"
          :parent-value="copySubjectForm.copySubjectType"
          v-validate="{
              required: !isInput.includes(copySubjectForm.copySubjectType)
                && copySubjectForm.copySubjectType !== 'usuarios'
            }"
          :disabled="!copySubjectForm.copySubjectType"
          :danger="errors.has(`${scope}.copySubject`)"
          :danger-text="errors.first(`${scope}.copySubject`)"
          ref="copySubject"
        />
        <list-user
          v-if="
              !isInput.includes(copySubjectForm.copySubjectType)
                && copySubjectForm.copySubjectType === 'usuarios'
            "
          class="w-100"
          withFilters
          rolId="7441a75e-80b9-486a-8595-34c487a56dd9"
          autocomplete
          label="Lista de Destino"
          name="subject"
          v-model="copySubjectForm.copySubject"
          v-validate="{
              required: !isInput.includes(copySubjectForm.copySubjectType)
                && copySubjectForm.copySubjectType === 'usuarios'
            }"
          :disabled="!copySubjectForm.copySubjectType"
          :danger="errors.has(`${scope}.copySubject`)"
          :danger-text="errors.first(`${scope}.copySubject`)"
          ref="copySubject"
        />
        <vs-input
          v-if="isInput.includes(copySubjectForm.copySubjectType)"
          class="w-100"
          label="Ingrese un nombre"
          name="subject"
          v-model="copySubjectForm.copySubject"
          v-validate="{ required: isInput.includes(copySubjectForm.copySubjectType) }"
          :danger="errors.has(`${scope}.copySubject`)"
          :danger-text="errors.first(`${scope}.copySubject`)"
          key="subject-input"
        />
      </div>
      <div class="col-md-12" v-show="!isNumerationFile">
        <list-user
          class="w-100"
          withFilters
          rolId="7441a75e-80b9-486a-8595-34c487a56dd9"
          autocomplete
          label="Lista de Destino"
          name="subject"
          v-model="copySubjectForm.copySubject"
          v-validate="'required'"
          :disabled="!copySubjectForm.copySubjectType"
          :danger="errors.has(`${scope}.copySubject`)"
          :danger-text="errors.first(`${scope}.copySubject`)"
          ref="copySubject"
        />
      </div>
    </div>
    <div class="row mb-3" v-if="copySubjectForm.copySubjectType === 'docDigital'">
      <div class="col-12">
        <list-institutions-doc-digital
          class="w-100"
          autocomplete
          label="Lista de Instituciones DocDigital"
          name="subjectTypeDigitalDoc"
          v-model="copySubjectForm.copySubjectTypeDigitalDoc"
          :parent-value="copySubjectForm.copySubject"
          v-validate="{ required: copySubjectForm.copySubjectType === 'docDigital'}"
          :danger="errors.has(`${scope}.copySubjectTypeDigitalDoc`)"
          :danger-text="errors.first(`${scope}.copySubjectTypeDigitalDoc`)"
          ref="copySubjectTypeDigitalDoc"
        />
      </div>
      <div
        class="col-3"
        v-if="copySubjectForm.copySubjectType === 'docDigital'
        && copySubjectForm.copySubject !== ''
        && copySubjectForm.copySubject !== undefined"
      >
        <vs-checkbox
          v-model="selectAllDocDigitalCopy"
          class="mt-2"
          color="primary"
          v-on:change.native="selectDocDigitalCopy()"
          v-tooltip="'Seleccionar todas las instituciones DocDigital'"
          :disabled="disabledSelectAll"
        >
          Seleccionar todas
        </vs-checkbox>
      </div>
    </div>
    <div class="row mb-3" v-if="emailRequired.includes(copySubjectForm.copySubjectType)">
      <div class="col-12">
        <vs-input
          class="w-100"
          label="Correo Electrónico Persona Destinatario"
          name="copySubjectEmail"
          v-model="copySubjectForm.copySubjectEmail"
          v-validate="{
              required: emailRequired.includes(copySubjectForm.copySubjectType)
              ,
              email: true
            }"
          :danger="errors.has(`${scope}.copySubjectEmail`)"
          :danger-text="errors.first(`${scope}.copySubjectEmail`)"
        />
      </div>
    </div>
    <div class="row mb-3" v-if="copySubjectForm.copySubjectType === 'usuarios'">
      <div class="col-6">
        <vs-select
          autocomplete
          class="w-100 con-select autocompletex"
          label="Seleccione tipo de providencia"
          data-cy="copy-providence"
          v-model="copySubjectForm.providence"
        >
          <vs-select-item
            :value="providenceTypes.KNOWLEDGE"
            text="Conocimiento"
          />
        </vs-select>
      </div>
      <div class="col-6">
        <label>Fecha Vencimiento</label>
        <b-form-datepicker
          locale="es"
          :min="minDate"
          placeholder="Fecha vencimiento"
          name="providenceExpiration"
          v-model="copySubjectForm.providenceExpiration"
          label-help="Puede usar las flechas del teclado y espacio"
        />
      </div>
    </div>
    <div class="row mb-3">
      <div class="col-12 d-flex align-items-end justify-content-end">
        <b-button
          data-cy="add-copy-button"
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="primary"
          v-on:click="addCopy()"
        >
          Agregar copia a
        </b-button>
      </div>
    </div>
  </div>
</template>
<script>

import Ripple from 'vue-ripple-directive';
import { mapGetters } from 'vuex';

import ListSubjectTypes from '@/febos/chile/lists/components/ListSubjectTypes';
import ListUser from '@/febos/chile/lists/components/ListUser';
import ProvidencesTypes from '@/febos/chile/dnt/mixins/ProvidencesTypes';
import ListInstitutionsDocDigital from '@/febos/chile/lists/components/ListInstitutionsDocDigital';
import ListSubjects from '@/febos/chile/lists/components/ListSubjects';
import ListGroups from '@/febos/chile/lists/components/ListGroups';
import ListOffices from '@/febos/chile/lists/components/ListOffices';
import ListSanitaryCompanies
from '@/febos/chile/dnt/components/wizard/companies/61221000-4/components/ListSanitaryCompanies';

export default {
  components: {
    ListSubjectTypes,
    ListInstitutionsDocDigital,
    ListSanitaryCompanies,
    ListSubjects,
    ListUser,
    ListGroups,
    ListOffices
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      minDate: this.$moment().format('YYYY-MM-DD'),
      providenceTypes: ProvidencesTypes,
      commentary: '',
      emailRequired: ['personas', 'empresas', 'ministerios', 'personasJuridicas', 'organismoEstado'],
      isInput: ['personas', 'empresas', 'personasJuridicas', 'organismoEstado'],
      subjectForm: {
        subjectType: 'usuarios',
        providence: '',
        providenceExpiration: '',
        subject: '',
        subjectTypeDigitalDoc: '',
        subjectEmail: '',
      },
      copySubjectForm: {
        copySubjectType: 'usuarios',
        providence: '',
        providenceExpiration: '',
        copySubject: '',
        copySubjectTypeDigitalDoc: '',
        copySubjectEmail: '',
      },
      subjectsSelected: [],
      selectAllDocDigitalCopy: false,
    };
  },
  computed: {
    ...mapGetters('Dnts', ['participants']),
    ...mapGetters('Empresas', ['company']),
    ...mapGetters('List', [
      'docDigitalList'
    ]),
    isNumerationFile() {
      const { wizard } = this.$route.params;
      const route = this.$route.name === 'manage-file-tray';
      return (wizard === 'numOf' || wizard === 'numInt') || route;
    },
    disabledSelectAll() {
      return this.$refs.copySubjectTypeDigitalDoc.isDisabled;
    }

  },
  props: {
    scope: { type: String },
    isDocDigital: { type: Boolean }
  },
  methods: {
    async validateForm(scope) {
      const result = await this.$validator.validateAll(scope);
      return !!result;
    },
    async addCopy() {
      const isValid = await this.validateForm(this.scope);

      if (!isValid) {
        return;
      }

      const copySubjectType = this.$refs.copySubjectType.getOption();
      const copySubject = this.isInput.includes(this.copySubjectForm.copySubjectType)
        ? {
          label: this.copySubjectForm.copySubject,
          value: this.copySubjectForm.copySubject,
          id: this.copySubjectForm.copySubject
        }
        : this.$refs.copySubject.getOption();

      const copySubjectTypeDigitalDoc = this.$refs.copySubjectTypeDigitalDoc
        ? this.$refs.copySubjectTypeDigitalDoc.getOption()
        : {};

      if (this.copySubjectForm.copySubjectType === 'sanitarias') {
        if (copySubject.extra && copySubject.extra.correos.length) {
          copySubject.extra.correos.split(',').forEach((email) => {
            const row = {
              copySubjectType,
              copySubject,
              copySubjectTypeDigitalDoc,
              subjectEmail: email,
              providence: this.copySubjectForm.providence,
              providenceExpiration: this.copySubjectForm.providenceExpiration,
              allowMultipleTimes: true
            };
            this.$emit('add-copy', row);
          });
        } else {
          this.$bvToast.toast(
            'Esta sanitaria no tiene correo configurado',
            {
              title: '¡Oye!',
              variant: 'warning',
              pauseOnHover: true,
              solid: true,
              noAutoHide: true
            }
          );
        }
      } else {
        const row = {
          copySubjectType,
          copySubject,
          copySubjectTypeDigitalDoc,
          copySubjectEmail: this.copySubjectForm.copySubjectEmail,
          providence: this.copySubjectForm.providence,
          providenceExpiration: this.copySubjectForm.providenceExpiration
        };
        this.$emit('add-copy', row);
      }

      this.copySubjectForm.copySubject = '';
      this.copySubjectForm.providence = '';
      this.copySubjectForm.providenceExpiration = '';
      this.copySubjectForm.copySubjectTypeDigitalDoc = '';
      this.copySubjectForm.copySubjectEmail = '';
      await this.$validator.reset();
    },
    selectDocDigitalCopy() {
      if (!this.selectAllDocDigitalCopy) {
        this.$emit('clear-doc-digital');
        return;
      }

      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Heey!',
        text: 'Estás a punto de seleccionar todas las instituciones DocDigital como'
          + ' copia, esto hará que el expediente a crear sea distribuido a'
          + ' todos los correos de contacto',
        cancelText: 'Cancelar',
        acceptText: 'Confirmar',
        accept: async () => {
          const list = this.$refs.copySubjectTypeDigitalDoc.filteredList;
          const copySubjectType = this.$refs.copySubjectType.getOption();
          const copySubject = this.isInput.includes(this.copySubjectForm.copySubjectType)
            ? {
              label: this.copySubjectForm.copySubject,
              value: this.copySubjectForm.copySubject,
              id: this.copySubjectForm.copySubject
            }
            : this.$refs.copySubject.getOption();

          list.forEach((copyDocDigital) => {
            const row = {
              copySubjectType,
              copySubject,
              copySubjectTypeDigitalDoc: copyDocDigital,
              copySubjectEmail: this.copySubjectForm.copySubjectEmail,
              providence: this.copySubjectForm.providence,
              providenceExpiration: this.copySubjectForm.providenceExpiration,
              allowMultipleTimes: true
            };
            this.$emit('add-copy', row);
          });
          this.selectAllDocDigitalCopy = false;
          this.copySubjectForm.copySubject = '';
          this.copySubjectForm.providence = '';
          this.copySubjectForm.providenceExpiration = '';
          this.copySubjectForm.copySubjectTypeDigitalDoc = '';
          this.copySubjectForm.copySubjectEmail = '';
          await this.$validator.reset();
        },
        cancel: () => {
          this.selectAllDocDigitalCopy = false;
        }
      });
    }
  }
};
</script>
<style>

</style>
